import React from 'react';

function SevAbout() {



    return (
        <div id="toggle-me-contact-line" class="sev-title-line">
            <div id="toggle-me-contact-text" class="sev-title-text">
                <span>About --- Coming Soon</span>
            </div>
        </div>
    )
}
export default SevAbout;